import { createContext } from 'react';
import type { Project } from '@/services/projects';

export interface ProjectContextValue {
  activeProject: Project | null;
  projects: Project[];
  loading: boolean;
  error: string | null;
  setActiveProject(project: Project): void;
  refreshProjects(): Promise<void>;
}

export const ProjectContext = createContext<ProjectContextValue | null>(null);
